import { render, staticRenderFns } from "./AcademicPeriodsDataTable.vue?vue&type=template&id=430d0cdf&scoped=true&"
import script from "./AcademicPeriodsDataTable.vue?vue&type=script&lang=js&"
export * from "./AcademicPeriodsDataTable.vue?vue&type=script&lang=js&"
import style0 from "./AcademicPeriodsDataTable.vue?vue&type=style&index=0&id=430d0cdf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430d0cdf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VDataTable,VIcon,VOverlay,VProgressCircular,VTooltip})
